import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DnsRecordDto } from 'src/app/models/dns-records.model';
import { GeneralService } from 'src/app/services/general.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-dns-details',
  templateUrl: './dns-details.page.html',
  styleUrls: ['./dns-details.page.scss'],
  standalone: false,
})
export class DnsDetailsPage implements OnInit {

  isLoading = false

  id = ''
  dns_id = ''
  isCreate = true
  details = {
    type: 'A',
    data: {

    }
  }
  host = 'name'
  validator = {}

  // CAA, CERT, DNSKEY, DS, HTTPS, LOC, NAPTR, PTR, SMIMEA, SSHFP, SVCB, TLSA, URI
  type = [
    {
      type: 'A',
      value: 'Address',
      placeholder: '127.0.0.1'
    },
    {
      type: 'AAAA',
      value: 'Address',
      placeholder: '2001:0db8:85a3:0000:0000:8a2e:0370:7334'
    },
    {
      type: 'CNAME',
      value: 'Cname Data',
      placeholder: 'foo.example.io'
    },
    {
      type: 'MX',
      value: 'EXCHANGE',
      placeholder: 'mail.example.io'
    },
    {
      type: 'NS',
      value: 'NS dname',
      placeholder: 'ns1.nameserver.com'
    },
    {
      type: 'SRV',
      value: 'Target',
      placeholder: 'siphost.com'
    },
    {
      type: 'TXT',
      value: 'TXT Data',
      placeholder: 'Enter any text here'
    }
  ]



  typeObj = {
    'A': {
      type: 'A',
      title: 'Address',
      placeholder: '127.0.0.1'
    },
    'AAAA': {
      type: 'AAAA',
      title: 'Address',
      placeholder: '2001:0db8:85a3:0000:0000:8a2e:0370:7334'
    },
    'CNAME': {
      type: 'CNAME',
      title: 'Cname Data',
      placeholder: 'foo.example.io'
    },
    'MX': {
      type: 'MX',
      title: 'EXCHANGE',
      placeholder: 'mail.example.io'
    },
    'NS': {
      type: 'NS',
      title: 'NS dname',
      placeholder: 'ns1.nameserver.com'
    },
    'SRV': {
      type: 'SRV',
      title: 'Target',
      placeholder: 'siphost.com'
    },
    'TXT': {
      type: 'TXT',
      title: 'TXT Data',
      placeholder: 'Enter any text here'
    }
  }

  ttlOptions = [
    { label: "Auto", value: 1 },
    { label: "1 min (60)", value: 60 },
    { label: "2 min (120)", value: 120 },
    { label: "5 min (300)", value: 300 },
    { label: "10 min (600)", value: 600 },
    { label: "15 min (900)", value: 900 },
    { label: "20 min (1200)", value: 1200 },
    { label: "30 min (1800)", value: 1800 },
    { label: "1 hour (3600)", value: 3600 },
    { label: "2 hours (7200)", value: 7200 },
    { label: "5 hours (18000)", value: 18000 },
    { label: "12 hours (43200)", value: 43200 },
    { label: "1 day (86400)", value: 86400 }
  ]

  constructor(
    private navParams: NavParams,
    protected modalCtrl: ModalController,
    private http: HttpClient,
    private generalService: GeneralService
  ) {

  }

  async ngOnInit() {

    this.isLoading = true
    await new Promise((resolve) => setTimeout(() => {
      resolve(true)
    }, 3000))

    this.isLoading = false
    this.details = JSON.parse(JSON.stringify(this.navParams.get('details')))
    this.dns_id = this.navParams.get('dns_id')
    this.id = this.navParams.get('id')
    this.isCreate = this.navParams.get('isCreate')
    if (!this.details['ttl']) {
      this.details['ttl'] = 1
    }
  }

  async createDns() {
    let validateResult = await this.generalService.validateInput(this.details, DnsRecordDto, [])
    if (validateResult['status'] === 'FAIL') {

      this.generalService.showToast(Object.values(validateResult['result'])[0]['error_message'], 'error', 'top')
      this.validator = validateResult['result']
      return
    }

    this.details = validateResult['correctData']

    this.generalService.pleaseWait({ key: 'Please wait...' }, { key: 'We are creating your dns record...' })

    this.details['ttl'] = parseInt(this.details['ttl'])

    if (this.details['type'] === 'MX') {
      this.details['priority'] = parseInt(this.details['priority'])
    }

    if (this.details['type'] === 'SRV') {
      this.details['data']['port'] = parseInt(this.details['data']['port'])
      this.details['data']['priority'] = parseInt(this.details['data']['priority'])
      this.details['data']['weight'] = parseInt(this.details['data']['weight'])
    }

    try {
      let response = await firstValueFrom(
        (this.isCreate === true ? this.http.post(`${baseUrl}/domain/create-dns`, {
          dns_id: this.dns_id,
          id: this.id,
          record: this.details
        })

        : 

        this.http.put(`${baseUrl}/domain/update-dns`, {
          dns_id: this.dns_id,
          id: this.id,
          record: this.details
        }))
      );

      this.generalService.swalClose()

      if (response['status'] === 'SUCCESS') {
        this.generalService.showToast({ key: 'Created successfully' }, 'success', 'top')
        this.modalCtrl.dismiss(true)
      } else {
        this.generalService.showToast(response['message'] || { key: 'DomainFailedToSaveDnsRecord' }, 'error', 'top')
      }
    } catch (error) {
      this.generalService.swalClose()
      this.generalService.showToast(error?.message || { key: 'DomainFailedToSaveDnsRecord' }, 'error', 'top')
    }
  }

}
